var searchApp = angular.module("search", ["ngRoute", "core", "ui.bootstrap"]);

searchApp.config(["$locationProvider", "$compileProvider", function ($locationProvider, $compileProvider) {
    $locationProvider.html5Mode(true);
    $compileProvider.debugInfoEnabled(false);
}]);

var searchFiltersApp = angular.module("searchFilters", ["ngRoute", "core", "ui.bootstrap"]);

searchFiltersApp.config(["$locationProvider", "$compileProvider", function ($locationProvider, $compileProvider) {
    $locationProvider.html5Mode(true);
    $compileProvider.debugInfoEnabled(false);
}]);

angular.module("searchFilters").controller("Filters", ["$window", "$scope", function ($window, $scope) {
    var self = this;
    var ctrl = $window.SearchApi.currentSearch.controller;

    var bindControllerVars = function () {
        self.aggregations = ctrl.aggregations;
        self.results = ctrl.results;
        self.filters = ctrl.filters;
        self.searchNewQuery = ctrl.searchNewQuery;
        self.displayAggregationsAsList = ctrl.displayAggregationsAsList;
    };
    
    self.resetFilters = function () {
        ctrl.resetFilters();
    };

    self.onSearchCompleted = function () {
        bindControllerVars();
        $scope.$digest();
    };

    (function init() {
        bindControllerVars();
        $window.SearchApi.currentSearch.searchCompletedListeners.push(self.onSearchCompleted);
    })();
}]);

searchApp.controller("Search", ["$window", "$location", "$document", "ControlDependencies", "SearchParams", "ControlParams", "FilterParams", "SearchControlGrouper", "SearchService", "payload", function ($window, $location, $document, ControlDependencies, SearchParams, ControlParams, FilterParams, SearchControlGrouper, SearchService, payload) {
    var self = this;

    var pushGoogleAnalytics = function() {
        if ($window._gaq) {
            var url = $location.path() + "?" + SearchParams.asQueryString();
            $window._gaq.push(["_trackPageview", url]);
        }
    };

    var cleanPageParam = function () {
        if (self.params.page === 1) {
            delete(self.params.page);
        }
    };

    var updatePageTitle = function () {
        var title = $document[0].title.replace(/Page \d+ of/, "");
        if (!_.isUndefined(self.params.page) && self.params.page > 1) {
            title = "Page " + self.params.page + " of " + title;
        }

        $document[0].title = title;
    };

    self.resetControls = function () {
        self.controlValues = {};
        self.filters = {};
    };

    self.resetFilters = function () {
        self.filters = {};
        self.aggregations = [];
        self.searchNewQuery();
    };

    self.searchNewQuery = function () {
        self.params.page = 1;
        self.search();
    };

    self.search = function () {
        cleanPageParam();

        FilterParams.set(self.params, self.displayAggregationsAsList, self.aggregations, self.filters);
        ControlParams.set(self.params, self.controlValues);

        SearchService.search(self.params).then(
            function (results) {
                self.errorMessage = undefined;
                self.results = results;

                updatePageTitle();
                pushGoogleAnalytics();
                prepAggregations();

                $window.SearchApi.currentSearch.queryString = SearchParams.asQueryString();
                self.controlValues = ControlParams.parse(self.params);
                self.filters = FilterParams.parse(self.params, self.aggregations);

                _.forEach($window.SearchApi.currentSearch.searchCompletedListeners, function (listener) {
                    listener();
                });

                if ($(".product_list").length) {
                    $("html,body").animate({
                        scrollTop: $(".product_list").offset().top
                    }, "slow");
                }
            },
            function (err) {
                self.results = undefined;
                self.errorMessage = err;
            }
        );
    };

    self.hasResults = function () {
        return self.results && self.results.totalHits > 0;
    };

    self.wasSearchRun = function () {
        return self.results !== null;
    };

    self.hasError = function () {
        return !_.isUndefined(self.errorMessage);
    };

    self.getMaskedPlaceholderText = function (control) {
        var temp = _.map(control.fieldSettings, function (field) {
            return field.data.placeholder;
        });

        return temp.join(control.data.delimiter);
    };

    var initParams = function () {
        self.params = SearchParams.getParams();

        var defaults = {
            query: "",
            groupBy: payload.settings.defaultGrouping,
            sortBy: SearchParams.getParam("sortBy", payload.settings.defaultSort + "_" + payload.settings.defaultSortOrder),
            page: 1,
            limit: payload.settings.defaultPaging
        };

        _.forEach(defaults, function (def, key) {
            if (_.isUndefined(self.params[key])) {
                self.params[key] = def;
            }
        });

        self.params.limit = parseInt(self.params.limit);
    };

    var prepAggregations = function () {
        var temp = [];

        if (self.hasResults()) {
            _.forEach(self.results.aggregations, function (aggregation, name) {
                _.forEach(aggregation.buckets, function (aggregationItem) {
                    aggregationItem.type = aggregation.type;
                    aggregationItem.name = name;
                    temp.push(aggregationItem);
                });
            });
        }

        self.aggregations = temp;
    };

    var prepCategoryControl = function () {
        var categoryControl = _.find(self.controls, function (control) {
            return control.isDropdown && control.fieldSettings[0].field === "categories";
        });

        if (categoryControl) {
            var temp = categoryControl.options;
            delete categoryControl.options;
            categoryControl.options = prepCategoryControlOptions(temp, 1);
        }
    };

    var prepCategoryControlOptions = function (options, indent) {
        var temp = [];
        _.forEach(options, function (option) {
            option.description = new Array(indent).join("-") + option.name;
            delete option.name;
            temp.push(option);

            if (option.children) {
                temp = temp.concat(prepCategoryControlOptions(option.children, indent + 1));
                delete option.children;
            }
        });

        return temp;
    };

    var initApi = function () {
        $window.SearchApi = {
            currentSearch: {
                id: payload.settings.id,
                queryString: SearchParams.asQueryString(),
                groupBy: self.params.groupBy,
                urlMappings: payload.urlMappings,
                controller: self,
                searchCompletedListeners: []
            }
        };
    };

    (function init() {
        self.results = payload.results;

        self.controls = payload.settings.controls;
        self.groupingFieldSettings = payload.settings.groupingFieldSettings;
        self.pagingSettings = payload.settings.pagingSettings;
        self.sortingFieldSettings = payload.settings.sortingFieldSettings;
        self.displayAggregationsAsList = payload.settings.displayAggregationsAsList;

        self.shouldDisplaySortingOptions = self.sortingFieldSettings.length > 1;
        self.shouldDisplayGroupingOptions = self.groupingFieldSettings.length > 0;
        self.shouldDisplayPagingOptions = self.pagingSettings && self.pagingSettings.length > 1;

        initParams();
        prepAggregations();
        prepCategoryControl();

        self.controlValues = ControlParams.parse(self.params);
        self.filters = FilterParams.parse(self.params, self.aggregations);
        self.groups = SearchControlGrouper.group(self.controls);

        ControlDependencies.setup(self, payload.settings);

        initApi();

        if ($window.location.hash !== "") {
            self.search();
        }
    })();
}]);

angular.module("search").controller("SearchPages", ["$sce", "searchPage", "searchPageSearches", "translations", function ($sce, searchPage, searchPageSearches, translations) {
    var self = this;

    self.getTranslatedName = function (name) {
        return translations.names[name];
    };

    (function init() {
        searchPage.headerContent = $sce.trustAsHtml(searchPage.headerContent);
        searchPage.footerContent = $sce.trustAsHtml(searchPage.footerContent);
        self.searchPage = searchPage;

        _.forEach(searchPageSearches, function (searchPageSearch) {
            searchPageSearch.headerContent = $sce.trustAsHtml(searchPageSearch.headerContent);
            searchPageSearch.footerContent = $sce.trustAsHtml(searchPageSearch.footerContent);
        });
        self.searchPageSearches = searchPageSearches;
    })();
}]);

angular.module("search").directive("searchControls", ["$window", "ControlDependencies", "rootUrl", "viewsLocation", "ControlParams", "SearchControlGrouper", "QueryStringBuilder", function ($window, ControlDependencies, rootUrl, viewsLocation, ControlParams, SearchControlGrouper, QueryStringBuilder) {
    return {
        restrict: "E",
        replace: false,
        scope: {
            search: "=ngModel"
        },
        controllerAs: "controlsCtrl",
        controller: ["$scope", "$element", "$attrs", "translations", function ($scope, $element, $attrs, translations) {
            var self = this;

            self.getMaskedPlaceholderText = function (control) {
                var temp = _.map(control.fieldSettings, function (field) {
                    return field.data.placeholder;
                });

                return temp.join(control.data.delimiter);
            };

            self.resetControls = function () {
                self.controlValues = {};
            };

            self.runSearch = function () {
                var params = {};
                ControlParams.set(params, self.controlValues);

                $window.location = rootUrl + self.search.url + "?" + QueryStringBuilder.build(params);
            };

            self.getOptionLabel = function (control) {
                if (control.groupName === null) {
                    return "";
                }

                return control.label;
            };

            (function init() {
                self.translations = translations;
                self.search = $scope.search;
                self.controlValues = {};

                self.controls = SearchControlGrouper.group(self.search.controls);
                ControlDependencies.setup(self, self.search);
            })();
        }],
        templateUrl: viewsLocation + "/SearchControls.html"
    };
}]);

searchApp.factory("ControlDependencies", ["HttpService", function (HttpService) {
    return {
        setup: function (vm, search) {
            var self = this;
            var dependencies;
            var controlIndex;
            var invDependencies;

            var clearDependentControls = function (control) {
                var temp = control.id;
                while (temp) {
                    if (dependencies[temp]) {
                        var dependencyId = dependencies[temp];
                        controlIndex[dependencyId].options = [];
                        temp = dependencyId;
                    } else {
                        temp = null;
                    }
                }
            };

            var getCurrentDependentValues = function (control) {
                var temp = control.id;
                var values = {};
                values[control.id] = vm.controlValues[control.id];

                while (temp) {
                    if (invDependencies[temp]) {
                        var invDependencyId = invDependencies[temp];
                        values[controlIndex[invDependencyId].id] = vm.controlValues[controlIndex[invDependencyId].id];
                        temp = invDependencies[temp];
                    } else {
                        temp = null;
                    }
                }

                return values;
            };

            var setupControlDependencies = function () {
                dependencies = {};
                _.forEach(search.controls, function (control) {
                    var data = control.fieldSettings[0].data;
                    if (control.isDropdown && data && data.dependentOn) {
                        var dependentOnId = control.fieldSettings[0].data.dependentOn;
                        dependencies[dependentOnId] = control.id;

                        if (vm.controlValues[control.id]) {
                            var temp = vm.controlValues[control.id];
                            control.options = [
                                {
                                    id: temp,
                                    description: temp
                                }
                            ];
                        }
                    }
                });

                invDependencies = _.invert(dependencies);
            };

            var populateControl = function (control, shouldClearControls) {
                if (dependencies[control.id] || invDependencies[control.id]) {
                    if (shouldClearControls) {
                        clearDependentControls(control);
                    }

                    if (dependencies[control.id]) {
                        var controlValues = getCurrentDependentValues(control);
                        if (controlValues) {
                            var lookupControl = controlIndex[dependencies[control.id]];

                            var data = {
                                searchId: search.id,
                                control: lookupControl,
                                controlValues: controlValues
                            };

                            HttpService.post({
                                url: "search/control-dependency-lookup",
                                data: data
                            }).then(function (data) {
                                lookupControl.options = data;
                            });
                        }
                    }
                }
            };

            var prePopulateDependentDropdownOptions = function () {
                _.forEach(invDependencies, function (id) {
                    if (vm.controlValues[id]) {
                        populateControl(controlIndex[id], false);
                    }
                });
            };

            vm.shouldShowControlLabel = function (control) {
                return control.data.shouldDisplayLabel && (!control.isDropdown || (control.isDropdown && control.options && control.options.length > 0));
            };

            vm.getControlLabelClassName = function (control) {
                return control.dasherisedLabel;
            };

            vm.getGroupClassName = function (group) {
                return group.dasherisedGroupName;
            };

            vm.shouldShowDropdownControl = function (control) {
                return control.isDropdown;
            };

            vm.shouldDisable = function (control) {
                return !control.options || control.options.length === 0;
            };

            vm.onDropdownChanged = function (control) {
                populateControl(control);
            };

            controlIndex = _.indexBy(search.controls, "id");
            setupControlDependencies();
            prePopulateDependentDropdownOptions();
        }
    };
}]);

searchApp.factory("ControlParams", function () {
    return {
        parse: function (params) {
            temp = {};
            _.forEach(params, function (value, key) {
                var regex = /controls\[(.*)\]$/;
                var matches = key.match(regex);
                if (matches) {
                    var controlName = matches[1];
                    var controlValue = decodeURIComponent(value);

                    temp[controlName] = controlValue;

                    delete params[key];
                }
            });

            return temp;
        },
        set: function (params, values) {
            _.forEach(values, function (value, key) {
                if (value) {
                    params["controls[" + key + "]"] = value;
                }
            });
        }
    };
});

searchApp.factory("FilterParams", function () {
    return {
        parse: function (params, aggregations) {
            var filters = {};

            _.forEach(params, function (value, key) {
                var regex = /Filters\[(.*)\]\[(.*)\]$/;
                var matches = key.match(regex);
                if (matches) {
                    var filterName = matches[1];
                    var filterValue = decodeURIComponent(matches[2]);

                    var temp = _.find(aggregations, function (aggregation) {
                        return aggregation.name === filterName && aggregation.key === filterValue;
                    });

                    if (temp) {
                        temp.selected = true;
                        filters[filterName] = temp;
                    }

                    delete params[key];
                }
            });

            return filters;
        },
        set: function (params, displayAsList, aggregations, filters) {
            var temp = displayAsList ? _.filter(aggregations, "selected") : _.filter(filters, function (filter) { return filter !== null; });

            _.forEach(temp, function (aggregationItem) {
                var paramsKey = aggregationItem.type + "Filters[" + aggregationItem.name + "][" + encodeURIComponent(aggregationItem.key) + "]";
                params[paramsKey] = 1;
            });
        }
    };
});

searchApp.factory("SearchControlGrouper", function () {
    return {
        group: function (controls) {
            var groupIndexes = {};
            _.forEach(controls, function (control) {
                if (control.groupName && groupIndexes[control.groupName] === undefined) {
                    groupIndexes[control.groupName] = control.position;
                }
            });

            var temp = {};
            _.forEach(controls, function (control) {
                if (control.groupName) {
                    var groupIndex = groupIndexes[control.groupName];
                    if (!temp[groupIndex]) {
                        temp[groupIndex] = [];
                    }

                    temp[groupIndex].push(control);
                } else {
                    temp[control.position] = [control];
                }
            });

            temp = _.map(temp, function(item) {
                if (item.length > 1) {
                    return {
                        isGroup: true,
                        groupName: item[0].groupName,
                        dasherisedGroupName: item[0].dasherisedGroupName,
                        controls: item
                    };
                }

                return item[0];
            });

            return temp;
        }
    };
});

searchApp.factory("SearchService", ["$window", "$q", "HttpService", "SearchParams", function ($window, $q, HttpService, SearchParams) {
    return {
        search: function (data) {
            zsMessages.cursor_follow("Performing search...");
            SearchParams.setParams(data);

            return HttpService.post({
                url: "?" + SearchParams.asQueryString(),
            }).then(
                function (results) {
                    $window.SearchApi.currentSearch.groupBy = _.isUndefined(data.groupBy) ? "" : data.groupBy;
                    $window.SearchApi.currentSearch.buildResults(results);

                    return results;
                },
                function (err) {
                    $window.SearchApi.currentSearch.buildResults([]);

                    return $q.reject(err);
                }
            ).finally(function () {
                zsMessages.cursor_follow(false);
            });
        }
    };
}]);
